
import { Component, Vue } from "vue-property-decorator";
import SpecialPageTep from "@/template/special/SpecialPage.vue";
@Component
export default class SpecialPage extends SpecialPageTep {}
